import React from 'react';
import { withNamespaces, Trans } from 'react-i18next';
import { staticURL } from 'core/url';

import Heading from 'components/Heading';
import Paragraph from 'components/Paragraph';

import {
  LargePanelSectionWrapper,
  CollapseWrapper,
  ContentWrapper,
} from './onboarding.styled';

const MultiPartFile = () => {
  // return (
  //   <LargePanelSectionWrapper first>
  //     <Heading level='1' size='xlarge' margin='0 0 1rem 0'>
  //       <Trans>Oops!</Trans>
  //     </Heading>
  //     <CollapseWrapper>
  //       <ContentWrapper>
  //         <Paragraph>
  //           <Trans>
  //             <strong>
  //               Quoting is only available on single part CAD files.
  //             </strong>
  //           </Trans>
  //         </Paragraph>
  //         <Paragraph>
  //           <Trans>
  //             If you would like to quote individual parts from this assembly,
  //             please upload them seperately for now. Thanks!
  //           </Trans>
  //         </Paragraph>
  //         <Paragraph>
  //           <Link name='home'>
  //             <Button
  //               text='Upload Part'
  //               icon='arrow_right'
  //               iconPosition='right'
  //             />
  //           </Link>
  //         </Paragraph>
  //       </ContentWrapper>
  //     </CollapseWrapper>
  //   </LargePanelSectionWrapper>
  // );
  return (
    <LargePanelSectionWrapper first>
      <Heading level='1' size='xlarge' margin='0 0 1rem 0'>
        <Trans>Get quotes for any part.</Trans>
      </Heading>
      <CollapseWrapper>
        <ContentWrapper>
          <Paragraph>
            <Trans>
              <strong>
                Right-click the part in your assembly and then &quot;Make
                Part&quot;.
              </strong>
            </Trans>
          </Paragraph>
          <Paragraph>
            <Trans>
              We will extract and share only this Part of your Assembly with any
              match-made Manufacturers.
            </Trans>
          </Paragraph>
        </ContentWrapper>
      </CollapseWrapper>
      <img
        style={{ marginTop: '1.5rem', width: '85%' }}
        src={staticURL('assets/marketplace/make-part.svg')}
        alt='Abstract geometric illustration'
      />
    </LargePanelSectionWrapper>
  );
};

export default withNamespaces()(MultiPartFile);
